import {
  CONSENT_TYPE_OPCF_43_DECLINE,
  CONSENT_TYPE_OPCF_44_DECLINE,
  CONSENT_TYPE_OPCF_20_DECLINE,
  CONSENT_TYPE_OPCF_27_DECLINE,
  CONSENT_TYPE_ACCIDENT_WAIVER_DECLINE,
  CONSENT_TYPE_MINOR_CONVICTION_DECLINE,
  CONSENT_TYPE_PHYSICAL_DAMAGE_DECLINE,
  CONSENT_TYPE_DCPD_DECLINE,
} from '../constants';

export interface CoverageDeclineConfig {
  title: string;
  warningTitle: string;
  warningDescription?: string;
  attestationText: string;
}

export const COVERAGE_DECLINE_CONFIG: Record<number, CoverageDeclineConfig> = {
  [CONSENT_TYPE_OPCF_43_DECLINE]: {
    title: 'OPCF 43 - Waiver of Depreciation Coverage Decline',
    warningTitle: 'OPCF 43 - Waiver of Depreciation is a recommended coverage.',
    attestationText:
      'I have advised my client of the OPCF 43 - Waiver of Depreciation coverage and its importance. Client has agreed to opt out of this coverage regardless of recommendation.',
  },
  [CONSENT_TYPE_OPCF_44_DECLINE]: {
    title: 'OPCF 44 - Family Protection Coverage Decline',
    warningTitle: 'OPCF 44 - Family Protection is a recommended coverage.',
    attestationText:
      'I have advised my client of the OPCF 44 - Family Protection coverage and its importance. Client has agreed to opt out of this coverage regardless of recommendation.',
  },
  [CONSENT_TYPE_OPCF_20_DECLINE]: {
    title: 'OPCF 20 - Loss of Use Coverage Decline',
    warningTitle: 'OPCF 20 - Loss of Use is a recommended coverage.',
    warningDescription:
      'Loss of Use coverage provides reimbursement for transportation expenses (such as rental car costs) while your vehicle is being repaired following a covered loss. Without this coverage, you would be responsible for all transportation costs during the repair period.',
    attestationText:
      'I have advised my client of the OPCF 20 - Loss of Use coverage and its importance. Client has agreed to opt out of this coverage regardless of recommendation.',
  },
  [CONSENT_TYPE_OPCF_27_DECLINE]: {
    title: 'OPCF 27 - Non-Owned Auto Coverage Decline',
    warningTitle:
      'OPCF 27 - Legal Liability for Damage to Non-Owned Automobiles is a recommended coverage.',
    warningDescription:
      "This coverage protects you when driving vehicles you don't own, such as rental cars or borrowed vehicles. Without this coverage, you would be personally liable for any damage caused to a non-owned vehicle while in your care.",
    attestationText:
      'I have advised my client of the OPCF 27 - Legal Liability for Damage to Non-Owned Automobiles coverage and its importance. Client has agreed to opt out of this coverage regardless of recommendation.',
  },
  [CONSENT_TYPE_ACCIDENT_WAIVER_DECLINE]: {
    title: 'Accident Waiver Coverage Decline',
    warningTitle: 'Accident Waiver is a recommended coverage.',
    attestationText:
      'I have advised my client of the Accident Waiver coverage and its importance. Client has agreed to opt out of this coverage regardless of recommendation.',
  },
  [CONSENT_TYPE_MINOR_CONVICTION_DECLINE]: {
    title: 'Minor Conviction Protection Decline',
    warningTitle: 'Minor Conviction Protection is a recommended coverage.',
    attestationText:
      'I have advised my client of the Minor Conviction Protection coverage and its importance. Client has agreed to opt out of this coverage regardless of recommendation.',
  },
  [CONSENT_TYPE_PHYSICAL_DAMAGE_DECLINE]: {
    title: 'Physical Damage Coverage Decline',
    warningTitle:
      'Physical Damage Coverage protects your vehicle against loss or damage.',
    warningDescription:
      'This includes Collision, Comprehensive, and All Perils coverages. By declining all physical damage coverage, the vehicle will not be covered for damage from accidents, theft, vandalism, weather events, or other perils.',
    attestationText:
      'I have advised my client of the physical damage coverage options and their importance. Client has agreed to decline all physical damage coverage regardless of recommendation.',
  },
  [CONSENT_TYPE_DCPD_DECLINE]: {
    title: 'DCPD Coverage Decline',
    warningTitle:
      'Direct Compensation - Property Damage (DCPD) is a recommended coverage.',
    warningDescription:
      "DCPD covers damage to your vehicle and its contents when another driver is at fault. This coverage allows you to claim directly from your own insurer rather than pursuing the at-fault driver's insurance company.",
    attestationText:
      'I have advised my client of the DCPD coverage and its importance. Client has agreed to opt out of this coverage regardless of recommendation.',
  },
};
